export enum FilteredStatus {
  All = -1,
  Active = 1,
  Archive = 0,
}
